import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    copyLink: 'Copy payment link',
    delete: 'Delete',
    download: 'Download',
    duplicate: 'Duplicate',
    edit: 'Edit',
    help: 'Help',
    send: 'Send to {0}',
    sendByMyself: 'Send by myself',
    sendWithShine: 'Send with Shine',
  },
  fr: {
    copyLink: 'Copier le lien de paiement',
    delete: 'Supprimer',
    download: 'Télécharger',
    duplicate: 'Dupliquer',
    edit: 'Modifier',
    help: 'Aide',
    send: 'Envoyer à {0}',
    sendByMyself: 'Envoyer par moi-même',
    sendWithShine: 'Envoyer avec Shine',
  },
} as const);

export default locales;
